// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"_1ac6_Wrapper","isLoading":"_3Bp4_isLoading","Green":"_2k0b_Green","Blue":"_2420_Blue"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Wrapper/Wrapper.module.scss
// module id = 449
// module chunks = 42